import axios from 'axios';
import qs from 'qs'
const ajax = {
  // 获取i18n种类
  GET_LANGUAGE_TYPE: '/get/i18n_type'
};

const API_PATH_PRE_FIX = '/api';

// 增加前缀
let INTERFACE = {};
for (let key in ajax) {
  INTERFACE[key] = API_PATH_PRE_FIX + ajax[key];
}

/**
 * 获取 i18n 的种类
 */
function getI18nType() {
  // 这里需要先调用后端保存的语言
  return axios.get(INTERFACE.GET_LANGUAGE_TYPE);
}

/**
 * 获取i18n 配置json
 *
 * @param language
 * @private
 */
function getI18n(language = 'zh') {
  return axios.get('/static/i18n/' + language + '/index.json').then((data) => {
    window.I18n = data;
  });
}

function getfinanceList(data) {
  var c = 'policy/v1/ciq/policys?'
  return axios.get(c, {params: data}).catch(function (error) {
    console.log(error)
  })
}

function getuserInfo() {
  var c = 'agent/v1/agent/current?'
  return axios.get(c).catch(function (error) {
    console.log(error)
  })
}
// 交班记录
function getchangeList(data) {
  var c = 'apply/v1/ciq/works?'
  return axios.get(c, {params: data}).catch(function (error) {
    console.log(error)
  })
}
// 交班信息
function getchangeuserInfo() {
  var c = 'apply/v1/ciq/work?'
  return axios.get(c).catch(function (error) {
    console.log(error)
  })
}

// 报表
function getreportList(data) {
  var c = 'policy/v1/ciq/policy/report?'
  return axios.get(c, {params: data}).catch(function (error) {
    console.log(error)
  })
}

// 代理人列表
function getagentNameList(data) {
  var c = 'agent/v1/user/agents?'
  return axios.get(c, {params: data}).catch(function (error) {
    console.log(error)
  })
}

// 机构树列表
function getbranchList(data) {
  var c = 'agent/v1/user/branch/trees?'
  return axios.get(c, {params: data}).catch(function (error) {
    console.log(error)
  })
}

function postchangeOrder(data) {
  var c = 'apply/v1/ciq/work?'
  return axios.post(c, {params: data}).catch(function (error) {
    console.log(error)
  })
}

// 修改密码
function changePassword(data) {
  var c = 'auth/user/password/change?'
  return axios.get(c, {params: data}).catch(function (error) {
    console.log(error)
  })
}
// 登陆
function login(username, password) {
  return axios.post('auth/oauth/token', qs.stringify({username: username, password: password, grant_type: 'password', scope: 'read', client_id: 'client_test', client_secret: 'secret_test'}), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export default {
  getI18n,
  getI18nType,
  getfinanceList,
  getuserInfo,
  getchangeList,
  getchangeuserInfo,
  getreportList,
  getagentNameList,
  getbranchList,
  postchangeOrder,
  changePassword,
  login
};



// WEBPACK FOOTER //
// ./src/interface.js